export default __webpack_public_path__ + "static/media/social-cards-video.8c5264f0.mp4";